import React from 'react'
import ReactDOM from 'react-dom/client'
import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom'

/** Anciennes pages Factures / Services : redirige vers l'onglet correspondant de Comptabilité en gardant les paramètres (new=1, edit=…). */
function RedirectTab({ tab }: { tab: string }) {
  const { search } = useLocation()
  const p = new URLSearchParams(search); p.set('tab', tab)
  return <Navigate to={`/admin/comptabilite?${p.toString()}`} replace />
}
import { UploadProvider } from './lib/uploads'
import './index.css'
import { AuthProvider, useAuth } from './lib/auth'
import Landing from './pages/Landing'
import PortfolioPublic from './pages/PortfolioPublic'
import Login from './pages/Login'
import AITools from './pages/AITools'
import Portail from './pages/Portail'
import Admin from './pages/Admin'
import Leads from './pages/Leads'
import Livrables from './pages/Livrables'
import Revue from './pages/Revue'
import Portfolio from './pages/Portfolio'
import Fichiers from './pages/Fichiers'
import Clients from './pages/Clients'
import ClientDetail from './pages/ClientDetail'
import Projets from './pages/Projets'
import FacturePrint from './pages/FacturePrint'
import Rencontres from './pages/Rencontres'
import MotDePasse from './pages/MotDePasse'
import Comptabilite from './pages/Comptabilite'

/** Navigation côté client pour tous les liens internes : les téléversements en cours continuent. */
function LinkInterceptor() {
  const nav = useNavigate()
  useEffect(() => {
    const h = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
      const a = (e.target as HTMLElement).closest('a')
      if (!a || a.target || a.hasAttribute('download') || a.origin !== window.location.origin) return
      const p = a.pathname
      if (p.startsWith('/papi') || p.startsWith('/s/') || p.startsWith('/api') || /\.[a-z0-9]{2,5}$/i.test(p)) return
      if (p === window.location.pathname && a.hash) return // ancre sur la même page
      e.preventDefault(); nav(p + a.search + a.hash)
    }
    document.addEventListener('click', h); return () => document.removeEventListener('click', h)
  }, [nav])
  return null
}

function Loading() {
  return <div className="min-h-screen bg-noir text-acier flex items-center justify-center">Chargement…</div>
}

function RequireAuth({ children, admin }: { children: React.ReactNode; admin?: boolean }) {
  const { loading, session, isAdmin } = useAuth()
  if (loading) return <Loading />
  if (!session) return <Navigate to="/login" replace />
  if (admin && !isAdmin) return <Navigate to="/portail" replace />
  return <>{children}</>
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <LinkInterceptor />
        <UploadProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/portfolio" element={<PortfolioPublic />} />
          <Route path="/login" element={<Login />} />
          <Route path="/portail" element={<RequireAuth><Portail /></RequireAuth>} />
          <Route path="/revue/:id" element={<RequireAuth><Revue /></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth admin><Admin /></RequireAuth>} />
          <Route path="/admin/clients" element={<RequireAuth admin><Clients /></RequireAuth>} />
          <Route path="/admin/clients/:id" element={<RequireAuth admin><ClientDetail /></RequireAuth>} />
          <Route path="/admin/projets" element={<RequireAuth admin><Projets /></RequireAuth>} />
          <Route path="/admin/factures" element={<RedirectTab tab="factures" />} />
          <Route path="/admin/comptabilite" element={<RequireAuth admin><Comptabilite /></RequireAuth>} />
          <Route path="/admin/services" element={<RedirectTab tab="services" />} />
          <Route path="/admin/rencontres" element={<RequireAuth admin><Rencontres /></RequireAuth>} />
          <Route path="/admin/videos" element={<Navigate to="/admin/livrables" replace />} />
          <Route path="/factures/:id" element={<RequireAuth><FacturePrint /></RequireAuth>} />
          <Route path="/mot-de-passe" element={<MotDePasse />} />
          <Route path="/admin/leads" element={<RequireAuth admin><Leads /></RequireAuth>} />
          <Route path="/admin/livrables" element={<RequireAuth admin><Livrables /></RequireAuth>} />
          <Route path="/admin/portfolio" element={<RequireAuth admin><Portfolio /></RequireAuth>} />
          <Route path="/admin/fichiers" element={<RequireAuth admin><Fichiers /></RequireAuth>} />
          <Route path="/outils-ia" element={<RequireAuth admin><AITools /></RequireAuth>} />
        </Routes>
        </UploadProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
)
